module.exports = __webpack_public_path__ + "img/hz.377a7061.png";